"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBaseType = exports.findInPrototypeChain = void 0;
const findInPrototypeChain_1 = require("./prototype/calculations/findInPrototypeChain");
Object.defineProperty(exports, "findInPrototypeChain", { enumerable: true, get: function () { return findInPrototypeChain_1.findInPrototypeChain; } });
const getBaseType_1 = require("./prototype/calculations/getBaseType");
Object.defineProperty(exports, "getBaseType", { enumerable: true, get: function () { return getBaseType_1.getBaseType; } });
//# sourceMappingURL=index.js.map